import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

interface TopicListSkeletonProps {
  count?: number;
}

const TopicListSkeleton: React.FC<TopicListSkeletonProps> = ({ count = 3 }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "p-6 rounded-xl border animate-pulse",
            isDarkMode ? "bg-dark-200 border-dark-300" : "bg-light-100 border-light-300"
          )}
        >
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-dark-300"></div>
            <div className="flex-1 space-y-2">
              <div className="h-5 bg-dark-300 rounded w-3/4"></div>
              <div className="h-4 bg-dark-300 rounded w-1/2"></div>
              <div className="flex gap-4 mt-2">
                <div className="h-4 bg-dark-300 rounded w-20"></div>
                <div className="h-4 bg-dark-300 rounded w-20"></div>
              </div>
            </div>
            <div className="hidden sm:block space-y-2">
              <div className="h-4 bg-dark-300 rounded w-24"></div>
              <div className="h-4 bg-dark-300 rounded w-16"></div>
              <div className="h-4 bg-dark-300 rounded w-20 mt-1"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopicListSkeleton;